import { Navigate } from "react-router-dom";
import { useContext } from 'react';
import AuthContext from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {

  const { loading, isAuthenticated } = useContext(AuthContext);

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}